import { AnySchema } from 'yup';

import Yup from '@tmh-website/services/validation.service';

import type {
  ProductSupportFormValuesUSA_EN,
  ProductSupportFormValuesWithoutCaptchaUSA_EN,
} from './ProductSupportFormUSA_EN.contracts';

export const INITIAL_VALUES: ProductSupportFormValuesUSA_EN = {
  company: '',
  issueType: '',
  customerType: '',
  email: '',
  firstName: '',
  gRecaptchaResponse: '',
  impactedChargers: '',
  lastName: '',
  message: '',
  phone: '',
  siteName: '',
};

type SalesFormValuesSchema = Record<keyof ProductSupportFormValuesUSA_EN, AnySchema>;

export const validationSchema = Yup.object<SalesFormValuesSchema>({
  company: Yup.string().required(),
  issueType: Yup.string().required(),
  customerType: Yup.string().required(),
  email: Yup.string().email().required(),
  firstName: Yup.string().required(),
  gRecaptchaResponse: Yup.string().required(),
  impactedChargers: Yup.string(),
  lastName: Yup.string().required(),
  message: Yup.string().required(),
  phone: Yup.string()
    .matches(/^(|\+?[0-9 -]+)$/)
    .required(),
  siteName: Yup.string(),
}).strict();

export const PRODUCT_SUPPORT_FORM_USA_EN_FIELD_TO_LABEL_TRANSLATION_KEY_MAP: Record<
  keyof ProductSupportFormValuesWithoutCaptchaUSA_EN,
  string
> = {
  company: 'global:label.company',
  issueType: 'blocks:staticForms.issueTypeLabel',
  customerType: 'blocks:staticForms.customerTypeLabel',
  email: 'global:label.email',
  firstName: 'global:label.firstName',
  impactedChargers: 'blocks:staticForms.impactedChargers',
  lastName: 'global:label.lastName',
  message: 'global:label.yourMessage',
  phone: 'global:label.phone',
  siteName: 'blocks:staticForms.siteName',
};
